<template>
    <div>
        <div class="page-top">
            <breadcrumb :mainName="mainName" :breadcrumbList="breadcrumbList"></breadcrumb>
            <a-button class="btn" type="primary" @click="createClient" v-if="userInfo.userType==2 || userInfo.userType === 7">创建</a-button>
        </div>
        <div class="table">
            <template>
                <a-table :dataSource="list" :columns="columns" :pagination="false" @change="changeList">
                    <div slot="filterDropdown"
                         slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                         class='custom-filter-dropdown'>
                        <a-input
                                v-ant-ref="c => searchInput = c"
                                :placeholder="`搜索${column.title}`"
                                :value="selectedKeys[0]"
                                @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                @pressEnter="() => handleSearch(selectedKeys, confirm)"
                                style="width: 188px; margin-bottom: 8px; display: block;"
                        />
                        <a-button
                                type='primary'
                                @click="() => handleSearch(selectedKeys, confirm)"
                                icon="search"
                                size="small"
                                style="width: 90px; margin-right: 8px"
                        >搜索
                        </a-button>
                        <a-button
                                @click="() => handleReset(clearFilters)"
                                size="small"
                                style="width: 90px"
                        >重置
                        </a-button>
                    </div>
                    <a-icon slot="filterIcon" slot-scope="filtered" type='search'
                            :style="{ color: filtered ? '#108ee9' : undefined }"/>
                    <template slot="realName" slot-scope="row">
                        <a href="javascript:;" @click="goClientDetail(row)">{{row.realName}}</a>
                    </template>

                </a-table>
            </template>
            <div class="page-wrap">
                <a-pagination
                        :pageSizeOptions="pageSizeOptions"
                        :total="total"
                        showSizeChanger
                        showQuickJumper
                        :pageSize="pageSize"
                        v-model="current"
                        @showSizeChange="onShowSizeChange"
                        @change="changePage"
                >
                </a-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import breadcrumb from '../common/Breadcrumb.vue'
    import api from '../../commomFun/api.js'
    import timeFormat from '../../commomFun/timeFormat';

    export default {
        components: {
            breadcrumb,
        },
        data() {
            return {
                // 面包屑
                breadcrumbList: [
                    {
                        name: '客户管理',
                        path: '/clientList'
                    },
                    {
                        name: '客户管理',
                        path: ''
                    }
                ],
                mainName: '客户列表',
                pageSizeOptions: ['10', '20', '30', '40'],
                current: 1,
                pageSize: 10,
                total: 0,
                list: [],
                searchText: '',
                searchInput: null,
                columns: [
                    {
                        title: '联系人',
                        key: 'realName',
                        scopedSlots: {
                            filterDropdown: 'filterDropdown',
                            filterIcon: 'filterIcon',
                            customRender: 'realName',
                        },
                    }, {
                        title: '职位',
                        dataIndex: 'position',
                        key: 'position',
                        scopedSlots: {customRender: 'position',},
                    },
                    {
                        title: '手机号',
                        dataIndex: 'phone',
                        key: 'phone',
                        scopedSlots: {customRender: 'phone',},
                    },
                    {
                        title: '公司名称',
                        dataIndex: 'cName',
                        key: 'cName',
                        scopedSlots: {
                            filterDropdown: 'filterDropdown',
                            filterIcon: 'filterIcon',
                            customRender: 'cName',
                        },
                    },
                    {
                        title: '所在城市',
                        dataIndex: 'rName',
                        key: 'rName',
                        scopedSlots: {customRender: 'rName',},
                    },
                    {
                        title: '公司品牌',
                        dataIndex: 'bTitle',
                        key: 'bTitle',
                        scopedSlots: {
                            filterDropdown: 'filterDropdown',
                            filterIcon: 'filterIcon',
                            customRender: 'bTitle',
                        },
                        ellipsis: true
                    },
                    {
                        title: '所有人',
                        dataIndex: 'saleName',
                        key: 'saleName',
                        scopedSlots: {customRender: 'saleName'},
                    },
                    {
                        title: '创建日期',
                        dataIndex: 'joinTime',
                        key: 'joinTime',
                        scopedSlots: {customRender: 'joinTime',},
                        sorter: true,
                    }
                ],
                userInfo:'',
                searchInfo:{
                    name:'',
                    bTitle:'',
                    companyName:'',
                    orderByCreateTimeAsc:0,//0-按照时间倒序排序（默认），1-按照时间正序排序
                }
            }
        },
        mounted() {
            this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
            this.getClientList()
        },
        methods: {
            changeList(pagination, filters, sorter) {
                console.log('params', pagination, filters, sorter);
                if(filters){
                    if(filters.realName){
                        this.searchInfo.name = filters.realName[0]
                    }
                    if(filters.cName){
                        this.searchInfo.companyName = filters.cName[0]
                    }
                    if(filters.bTitle){
                        this.searchInfo.bTitle = filters.bTitle[0]
                    }
                }
                if(sorter){
                    this.searchInfo.orderByCreateTimeAsc = sorter.order=='ascend'?1:0
                }
                this.getClientList()
            },
            //改变页数
            changePage(page, pageSize) {
                this.current = page;
                this.getClientList()
            },
            onShowSizeChange(current, pageSize) {
                this.current = current
                this.pageSize = pageSize
                this.getClientList()
            },
            //获取客户列表
            getClientList() {
                let info = {...this.searchInfo,pageNum:this.current,pageSize:this.pageSize}
                console.log(info);
                api.getApi('/customerManager/list',info).then(res=>{
                    if(res.data.code==200){
                        this.total = res.data.data.total
                        this.list = res.data.data.list
                    }else{
                        this.$message.warning(res.data.msg)
                    }
                })
            },
            handleSearch(selectedKeys, confirm) {
                confirm()
                this.searchText = selectedKeys[0]
            },

            handleReset(clearFilters) {
                clearFilters()
                this.searchText = ''
            },
            //创建客户
            createClient() {
                let obj = {
                    isEdit:false,
                    data:null
                }
                sessionStorage.setItem('clientData',JSON.stringify(obj))
                this.$router.push('/createClient')
            },
            //跳转客户详情
            goClientDetail(row) {
                console.log(row);
                sessionStorage.setItem('clientId', row.uID);
                this.$router.push('/clientDetail')
            }
        },
    }
</script>
<style scoped>
    .custom-filter-dropdown {
        padding: 8px;
        border-radius: 4px;
        background: #fff;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
    }

    .highlight {
        background-color: rgb(255, 192, 105);
        padding: 0px;
    }

    .page-top {
        position: relative;
        margin-bottom: 24px;
    }

    .btn {
        position: absolute;
        right: 24px;
        bottom: 14px;
    }

    .table {
        margin: 0 24px;
        padding: 32px 32px 78px;
        box-sizing: border-box;
        background: #FFFFFF;
    }
</style>
